import { base_account_config } from '$accountConfig/base.js';

export const vl = {
	flags: {
		has_location_bounds_migrated: false,
		allow_multi_delivery_slot_selection: true
	}
};

export const account_config = new Proxy(vl, {
	get(target, prop) {
		if (prop in target) {
			return target[prop];
		}
		return base_account_config[prop];
	}
});
